document.addEventListener('turbolinks:load', async () => {
    const pwaTourStatistic = document.getElementById('pwaTourStatistic')
    const pwaStations = document.getElementsByClassName('pwaStation')

    if (pwaTourStatistic !== null && pwaStations.length > 0 ) {
        for (let station of pwaStations) {
            const stationId = station.dataset.station
            // await to not send all requests at once. Better performance at local test
            await $.rails.ajax({
                url: `/pwa_statistics/station/${stationId}`,
                type: "get",
            })
        }
    }
})